import React from "react";
import {
  dataColumnFirst,
  dataColumnSecond,
  followLinks,
} from "../../constants";

const Footer = () => {
  return (
    <footer className="footer section">
      <h2 className="section-title">Footer</h2>
      <div className="footer-container bd-grid">
        <div className="footer-data">
          <h2 className="footer-title">Go to</h2>
          <ul>
            {dataColumnFirst.map((item, index) => (
              <li key={index}>
                <a href={item.link} className={item.className}>
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-data">
          <h2 className="footer-title">Sections</h2>
          <ul>
            {dataColumnSecond.map((item, index) => (
              <li key={index}>
                <a href={item.link} className={item.className}>
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-data">
          <h2 className="footer-title">FOLLOW</h2>
          {followLinks.map((item, index) => (
            <a className="footer-social" href={item.link} target="-blank">
              <i className={item.className}></i>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
